import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
    Box,
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Chip,
    Divider,
    CircularProgress,
    makeStyles,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    useMediaQuery,
    Fade,
    Slide,
    Grow,
    Collapse,
    Avatar,
    IconButton,
    Typography,

} from "@material-ui/core";
import { getToolboxesForUserAPI } from "../APIs/ToolboxUtility";
import Button from "components/CustomButtons/Button"
import {
    ExpandMore,
    ArrowBack,
    Launch as LaunchIcon,
    AllInclusive as ScienceIcon,
    Description as DescriptionIcon,
    Assignment as AssignmentIcon,
    School as SchoolIcon,
    Assessment as AssessmentIcon,
    LibraryBooks as LibraryBooksIcon,
    Create as CreateIcon,
    Email as EmailIcon,
    Business as BusinessIcon,
    Description as HandoutIcon,
    EmojiObjects as InsightIcon,
    Mic as PodcastIcon,
    Timeline as ProjectIcon,
    EmojiObjects,
    ListAlt,
    LocalAtm,
    MonetizationOn,
    Build,
} from "@material-ui/icons";
import { toolboxConstants } from "../../variables/toolboxConstants";
import WaveTitle from "./SolutionGenerator/WaveTitle";

const componentIcons = {
    "CONCEPT_LABS": ScienceIcon,
    "FORM": AssignmentIcon,
    "MODEL_DEVELOPMENT": AssessmentIcon,
    "MODEL_VALIDATION": AssessmentIcon,
    "COURSE": SchoolIcon,
    "RESEARCH_REPORT": DescriptionIcon,
    "WHITE_PAPER": LibraryBooksIcon,
    "BLOG": CreateIcon,
    "NEWS_LETTER": EmailIcon,
    "CASE_STUDY": BusinessIcon,
    "HANDOUT": HandoutIcon,
    "KEY_INSIGHTS": InsightIcon,
    "PODCAST": PodcastIcon,
    "PROJECT_PLAN": ProjectIcon,
    "SESSION": AssessmentIcon,
};
// ----------------- your existing constants (kept as-is) -----------------


// -------------------------- Updated styles with diagonal design --------------------------

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        overflow: 'hidden',
    },
    hero: {
        marginBottom: theme.spacing(2),
        position: 'relative',
        zIndex: 2,
        // border to the top and bottom of 1 px solid
    },
    heroTitle: {
        fontSize: '2.5rem',
        fontWeight: 700,
        marginBottom: theme.spacing(2),
        letterSpacing: 0.2,
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
        },
    },
    heroDescription: {
        fontSize: '1.125rem',
        maxWidth: '600px',
        lineHeight: 1.6,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        },
    },
    toolboxGrid: {
        position: 'relative',
        zIndex: 1,
    },
    toolboxCard: {
        position: 'relative',
        borderRadius: 24,
        overflow: 'hidden',
        background: 'linear-gradient(135deg, rgba(32, 103, 123, 1) 0%, rgba(32, 103, 123, 0.85) 60%, rgba(32, 103, 123, 0.7) 100%)',
        color: '#fff',
        height: '280px',
        cursor: 'pointer',
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            pointerEvents: 'none',
            backgroundImage: [
                // main diagonal divider wedge
                `linear-gradient(135deg,
                    transparent 0%,
                    transparent 57%,
                    rgba(32, 103, 123, 0.18) 57%,
                    rgba(32, 103, 123, 0.18) 61%,
                    transparent 61%
                )`,
                // thinner bands for depth
                `linear-gradient(135deg,
                    transparent 0%,
                    transparent 62%,
                    rgba(32, 103, 123, 0.12) 62%,
                    rgba(32, 103, 123, 0.12) 64%,
                    transparent 64%
                )`,
                `linear-gradient(135deg,
                    transparent 0%,
                    transparent 66%,
                    rgba(32, 103, 123, 0.08) 66%,
                    rgba(32, 103, 123, 0.08) 68%,
                    transparent 68%
                )`,
            ].join(","),
        },
        '&:hover': {
            transform: 'translateY(-8px) scale(1.02)',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        },
    },
    toolboxInner: {
        position: 'relative',
        zIndex: 2,
        padding: theme.spacing(3),
        height: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    toolboxLeft: {
        flex: 1,
        paddingRight: theme.spacing(3),
    },
    toolboxRight: {
        position: 'relative',
        clipPath: 'polygon(6% 0, 100% 0, 100% 100%, 0 100%)',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.12))',
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '120px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            clipPath: 'none',
            borderRadius: 12,
        },
    },
    toolboxIcon: {
        width: 80,
        height: 80,
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        color: '#ffffff',
        fontSize: '2.5rem',
        border: '1px solid rgba(255,255,255,0.25)',
        filter: 'drop-shadow(0 6px 18px rgba(0,0,0,0.25))',
    },
    toolboxTitle: {
        fontSize: '1.25rem',
        fontWeight: 600,
        color: '#ffffff',
        marginBottom: theme.spacing(1),
        letterSpacing: 0.1,
    },
    toolboxDescription: {
        fontSize: '0.95rem',
        color: 'rgba(255, 255, 255, 0.95)',
        lineHeight: 1.5,
        marginBottom: theme.spacing(2),
    },
    componentCount: {
        position: 'absolute',
        top: theme.spacing(2),
        right: theme.spacing(2),
        background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.3))',
        color: 'white',
        minWidth: 24,
        height: 24,
        borderRadius: 12,
        fontSize: '0.75rem',
        fontWeight: 600,
        border: '1px solid rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(10px)',
        zIndex: 3,
    },
    expandedView: {
        zIndex: 1000,
        overflow: 'auto',
        minHeight: '100vh',
    },
    backButton: {
        color: '#ffffff',
        backgroundColor: 'rgba(32, 103, 123, 0.99)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        '&:hover': {
            backgroundColor: 'rgba(32, 103, 123, 0.99)',
        },
    },
    expandedTitle: {
        fontSize: '2rem',
        fontWeight: 700,
        marginBottom: theme.spacing(1),
        letterSpacing: 0.2,

    },
    expandedDescription: {
        fontSize: '1.125rem',
        marginBottom: theme.spacing(4),
        lineHeight: 1.6,
    },
    componentCard: {
        background: 'linear-gradient(145deg, rgba(32, 103, 123, 0.75) 0%, rgba(32, 103, 123, 0.92) 100%)',
        backdropFilter: 'blur(15px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3),
        height: '200px',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        position: 'relative',
        color: '#ffffff',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.25)',
            background: 'linear-gradient(145deg, rgba(32, 103, 123, 0.65) 0%, rgba(32, 103, 123, 0.98) 100%)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            '& $launchButton': {
                opacity: 1,
                transform: 'translateY(0)',
            },
        },
    },
    componentIcon: {
        width: 60,
        height: 60,
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        color: '#ffffff',
        marginBottom: theme.spacing(2),
        fontSize: '2rem',
        border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    componentTitle: {
        fontSize: '1.125rem',
        fontWeight: 600,
        color: '#ffffff',
        marginBottom: theme.spacing(1),
        letterSpacing: 0.1,
    },
    componentDescription: {
        fontSize: '0.875rem',
        color: 'rgba(255, 255, 255, 0.9)',
        lineHeight: 1.4,
    },
    launchButton: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        opacity: 0,
        transform: 'translateY(10px)',
        transition: 'all 0.3s ease',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        color: '#ffffff',
        border: '1px solid rgba(255, 255, 255, 0.25)',
        backdropFilter: 'blur(10px)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
        },
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
    },
    loadingSpinner: {
        marginBottom: theme.spacing(2),
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(6),
    },
    '@keyframes slideInUp': {
        '0%': {
            opacity: 0,
            transform: 'translateY(30px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    '@keyframes fadeInScale': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.9)',
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
}));

const toolboxIcons = {
    "Idea Foundry Toolbox": EmojiObjects,
    "Content Creator Toolbox": ListAlt,
    "Financial Model Development Toolbox": LocalAtm,
    "Financial Model Validation Toolbox": MonetizationOn,
    default: Build,
}

const ToolboxCard = ({ toolbox, onExpand, index }) => {
    const classes = useStyles();
    const { toolbox_name, toolbox_description, components = [] } = toolbox;
    const IconComponent = toolboxIcons[toolbox_name] || toolboxIcons.default;

    return (
        <Grow
            in={true}
            timeout={600 + (index * 200)}
            style={{ transformOrigin: '0 0 0' }}
        >
            <Card
                className={classes.toolboxCard}
                onClick={() => onExpand(toolbox)}
                elevation={0}
            >
                <Chip
                    size="medium"
                    label={components.length}
                    className={classes.componentCount}
                />

                <div className={classes.toolboxInner}>
                    <div className={classes.toolboxLeft}>
                        <Typography variant="h6" className={classes.toolboxTitle}>
                            {toolbox_name}
                        </Typography>

                        <Typography variant="body2" className={classes.toolboxDescription}>
                            {toolbox_description}
                        </Typography>
                    </div>

                    <div className={classes.toolboxRight}>
                        <Avatar className={classes.toolboxIcon}>
                            <IconComponent fontSize="inherit" />
                        </Avatar>
                    </div>
                </div>
            </Card>
        </Grow>
    );
};

const ComponentCard = ({ componentKey, index }) => {
    const classes = useStyles();
    const component = toolboxConstants[componentKey];
    const IconComponent = componentIcons[componentKey] || CreateIcon;

    const handleLaunch = (e) => {
        e.stopPropagation();
        window.open(component.route, "_blank", "noopener,noreferrer");
    };

    return (
        <Slide
            direction="up"
            in={true}
            timeout={400 + (index * 100)}
        >
            <Card className={classes.componentCard} elevation={0} onClick={handleLaunch}>
                <Avatar className={classes.componentIcon}>
                    <IconComponent fontSize="inherit" />
                </Avatar>

                <Typography variant="h6" className={classes.componentTitle}>
                    {component.name}
                </Typography>

                <Typography variant="body2" className={classes.componentDescription}>
                    {component.description}
                </Typography>

                <IconButton
                    className={classes.launchButton}
                    size="small"
                    onClick={handleLaunch}
                >
                    <LaunchIcon fontSize="small" />
                </IconButton>
            </Card>
        </Slide>
    );
};

const ExpandedToolboxView = ({ toolbox, onBack }) => {
    const classes = useStyles();
    const { toolbox_name, toolbox_description, components = [] } = toolbox;

    return (
        <Fade in={true} timeout={300}>
            <div className={classes.expandedView}>
                <div className={classes.hero}>
                    <Divider style={{ marginBottom: '1rem' }} />
                    <Typography variant="h4">
                        
                        <WaveTitle text="QCreate Studio" />

                    </Typography>
                    <Typography variant="body1">
                        Discover powerful tools to create, innovate, and transform your ideas into reality.<br />
                        Choose from our comprehensive suite of professional toolboxes.
                    </Typography>
                    <Divider style={{ marginTop: '1rem' }} />
                </div>


                <Typography variant="h4" className={classes.expandedTitle}>

                    <IconButton
                        className={classes.backButton}
                        onClick={onBack}
                        size="small"
                    >
                        <ArrowBack />
                    </IconButton> <span style={{ marginLeft: '0.5rem' }}>{toolbox_name}</span>
                </Typography>

                <Typography variant="body1" className={classes.expandedDescription}>
                    {toolbox_description}
                </Typography>

                <Grid container spacing={3}>
                    {components.map((componentKey, index) => (
                        <Grid key={componentKey} item xs={12} sm={6} md={4}>
                            <ComponentCard
                                componentKey={componentKey}
                                index={index}
                            />
                        </Grid>
                    ))}
                </Grid>
            </div>
        </Fade>
    );
};

// --------------------- Main Page Component ---------------------
const ToolboxLandingPage = () => {
    const classes = useStyles();
    const [toolboxes, setToolboxes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedToolbox, setExpandedToolbox] = useState(null);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const res = await getToolboxesForUserAPI();
                if (mounted) {
                    setToolboxes(Array.isArray(res?.toolboxes) ? res.toolboxes : []);
                }
            } catch (err) {
                if (mounted) setError(err?.message || "Failed to load toolboxes.");
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, []);

    const handleExpandToolbox = (toolbox) => {
        setExpandedToolbox(toolbox);
    };

    const handleBackToGrid = () => {
        setExpandedToolbox(null);
    };

    if (expandedToolbox) {
        return (
            <ExpandedToolboxView
                toolbox={expandedToolbox}
                onBack={handleBackToGrid}
            />
        );
    }

    return (
        <Box className={classes.container}>
            <Fade in={!loading} timeout={800}>
                <div className={classes.hero}>
                    <Divider style={{ marginBottom: '1rem', textTransform: "none", fontWeight: "bold", }} />
                    <Typography variant="h4">
                        
                        <WaveTitle text="QCreate Studio" />

                    </Typography>
                    <Typography variant="body1">
                        Discover powerful tools to create, innovate, and transform your ideas into reality. <br />
                        Choose from our comprehensive suite of professional toolboxes.
                    </Typography>
                    <Divider style={{ marginTop: '1rem', marginBottom: '1rem' }} />
                </div>
            </Fade>

            {loading && (
                <div className={classes.loadingContainer}>
                    <CircularProgress size={48} className={classes.loadingSpinner} />
                    <Typography variant="h6" style={{ marginTop: 16 }}>
                        Loading your toolboxes...
                    </Typography>
                </div>
            )}

            {!loading && error && (
                <div className={classes.emptyState}>
                    <Typography color="error" variant="h6">
                        {error}
                    </Typography>
                </div>
            )}

            {!loading && !error && (
                <Fade in={true} timeout={1000}>
                    <div className={classes.toolboxGrid}>
                        {toolboxes.length === 0 ? (
                            <div className={classes.emptyState}>
                                <Typography variant="h6">
                                    No toolboxes available
                                </Typography>
                                <Typography variant="body1">
                                    Enable toolboxes in your profile to get started.
                                </Typography>
                            </div>
                        ) : (
                            <Grid container spacing={4}>
                                {toolboxes.map((toolbox, index) => (
                                    <Grid key={toolbox._id} item xs={12} sm={6} md={6} lg={6}>
                                        <ToolboxCard
                                            toolbox={toolbox}
                                            onExpand={handleExpandToolbox}
                                            index={index}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </div>
                </Fade>
            )}
        </Box>
    );
};

export default ToolboxLandingPage;